import React, {useState} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {useDispatch} from "react-redux";
import {BACKEND_URL, FORM_SUBMIT_BUTTON} from "../config/constants";
import CircularProgress from "@mui/material/CircularProgress";
import {setData} from "../store";
import {
    Box,
    Card,
    CardActions,
    CardContent,
    Fade,
    FormControl,
    FormControlLabel,
    IconButton,
    Modal,
    Radio,
    RadioGroup,
    TextField,
    Typography,
} from "@mui/material";
import ButtonComponent from "./Buttons/ButtonComponent";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import { PRINTOUT_DESIGN_OPTIONS, TEST_FORM_AMOUNTS } from "../config/constants";

const DataCaptureFormTest = ({headerText, description}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [template, setTemplate] = useState(PRINTOUT_DESIGN_OPTIONS[0].value);
    const [amountPaid, setAmountPaid] = useState(TEST_FORM_AMOUNTS[0].value);
    const [enlargedImage, setEnlargedImage] = useState(null);
    const [loading, setLoading] = useState(false);

    const apiURL = BACKEND_URL + `/breeze/api/manual-generate-qr`;

    const openImageModal = (imageUrl) => {
        setEnlargedImage(imageUrl);
    };

    const closeImageModal = () => {
        setEnlargedImage(null);
    };

    const handleOptionChange = (event) => {
        setTemplate(event.target.value);
    };

    const handleClick = async (event) => {
        event.preventDefault();
        try {
            setLoading(true);
            // Create an object with the form data
            const dataToBackend = {
                name: name,
                email: email,
                amountPaid: amountPaid,
                designChosen: template,
            };

            const response = await axios.post(apiURL, dataToBackend, {
                headers: {
                    "Content-Type": "application/json",
                },
            });

            if (response.data !== null) {
                console.log("Server generated QR ticket. URL is ", response.data);
                dispatch(
                    setData({
                        breezeQrUrl: response.data,
                    })
                );
                navigate("/test-thank-you");
            } else {
                console.log("Something wrong. Server did not generate our QR url");
            }
        } catch (error) {
            // Handle error
            console.error("Error submitting data:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                    <CircularProgress style={{color: '#F26522'}}/>
                </Box>
            ) : (
                <Card
                    style={{
                        maxWidth: "430px",
                        margin: "auto",
                        boxShadow: "1px 2px 8px rgba(0, 0, 0, 0.1)",
                    }}
                >
                    <CardContent>
                        <Typography fontSize={36} variant="h1" fontWeight={500} mt={3} mb={1}>
                            {headerText}
                        </Typography>
                        <Typography mb={4} variant="body1">
                            {description}
                        </Typography>

                        <form id="submit-form" onSubmit={handleClick}>
                            <Box
                                display={"flex"}
                                flexDirection={"column"}
                                justifyContent={"center"}
                                gap={2}
                            >
                                <TextField
                                    id="name"
                                    label="Name:"
                                    variant="outlined"
                                    type="text"
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    required
                                />
                                <TextField
                                    id="email"
                                    label="Email Address:"
                                    variant="outlined"
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                                <Typography mb={1} mt={4} variant="body3" style={{ textAlign: 'left' }}>
                                    Please select the amount you paid:
                                </Typography>
                                <FormControl>
                                    <RadioGroup
                                        aria-labelledby="amount-paid-radio-buttons-group-label"
                                        defaultValue={TEST_FORM_AMOUNTS[0].value}
                                        name="amount-paid-group"
                                        onChange={(e) => setAmountPaid(e.target.value)}
                                    >
                                        {TEST_FORM_AMOUNTS.map(({ label, value }) => (
                                            <FormControlLabel
                                                key={value}
                                                value={value}
                                                control={<Radio />}
                                                label={`$${label}`}
                                                checked={amountPaid === value}
                                                style={{ textAlign: 'left' }} // Align the radio buttons to the left
                                            />
                                        ))}
                                    </RadioGroup>
                                </FormControl>


                                <Typography mb={2} variant="body3" style={{textAlign: 'left'}}>
                                    Please choose a design for your printout<br/>Click on the each image to see an
                                    enlarged view.
                                </Typography>
                            
                            <Grid container spacing={2} rowGap={2}>
                                {PRINTOUT_DESIGN_OPTIONS.map(({label, value, imageUrl}) => (
                                    <Grid key={value}
                                          item xs={6}
                                          display={"flex"}
                                          flexDirection={"column"}
                                          alignItems={"center"}
                                          justifyContent={"space-between"}>
                                        <img
                                            src={imageUrl}
                                            alt={`Option ${value}`}
                                            style={{maxWidth: "100%", cursor: "pointer"}}
                                            onClick={() => openImageModal(imageUrl)}
                                        />
                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                defaultValue={PRINTOUT_DESIGN_OPTIONS[0].value}
                                                name="radio-buttons-group"
                                            >
                                                <FormControlLabel
                                                    value={value}
                                                    checked={template === value}
                                                    onChange={handleOptionChange}
                                                    control={<Radio/>}
                                                    label={label}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                ))}

                                {/* Image Modal */}
                                <Modal
                                    open={enlargedImage !== null}
                                    onClose={closeImageModal}
                                    aria-labelledby="image-modal"
                                    aria-describedby="image-content"
                                    disableAutoFocus
                                    closeAfterTransition
                                >
                                    <Fade in={enlargedImage !== null}>
                                        <div style={{textAlign: "center"}}>
                                            <IconButton
                                                edge="end"
                                                color="inherit"
                                                onClick={closeImageModal}
                                                aria-label="close"
                                                style={{position: "absolute", top: 10, right: 10}}
                                            >
                                                <CloseIcon/>
                                            </IconButton>
                                            <img
                                                src={enlargedImage}
                                                alt="Enlarged Image"
                                                style={{maxWidth: "100%"}}
                                            />
                                        </div>
                                    </Fade>
                                </Modal>
                            </Grid>
                            </Box>
                        </form>
                    </CardContent>
                    <CardActions style={{marginBottom: '5em'}}>
                        <ButtonComponent
                            backgroundColor={FORM_SUBMIT_BUTTON.backgroundColor}
                            borderColor={FORM_SUBMIT_BUTTON.borderColor}
                            buttonText={FORM_SUBMIT_BUTTON.buttonText}
                            color={FORM_SUBMIT_BUTTON.color}
                            width={FORM_SUBMIT_BUTTON.width}
                            onClick={() => {
                            }}
                            type="submit"
                            formID={"submit-form"}

                        />
                    </CardActions>
                </Card>
            )}
        </div>
    );
};

export default DataCaptureFormTest;
